module.exports = __webpack_public_path__ + "static/media/roundabout.d7dbb3df.svg";